class ListCardProduct extends HTMLElement {
  constructor() {
    super();

    this.productVariant = false;

    this.bindEvents();
    this.addAccessibilityAttributes();

    this.onClickAwayHandler = this.onClickAway.bind(this);
  }

  connectedCallback() {
    document.addEventListener("click", this.onClickAwayHandler);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.onClickAwayHandler);
  }

  bindEvents() {
    this.querySelectorAll(".list-card-product__listbox a").forEach((anchor) => {
      anchor.addEventListener("click", this.onClick.bind(this));
    });
    this.querySelector('[name="checker"]')?.addEventListener(
      "change",
      this.onChange.bind(this)
    );
  }

  addAccessibilityAttributes() {
    this.querySelectorAll(".list-card-product__listbox a").forEach((anchor) => {
      anchor.setAttribute("role", "button");
    });
  }

  onClickAway(event) {
    const detailsElement = this.querySelector("details");
    const summaryElement = this.querySelector("summary");
    if (summaryElement && !summaryElement.contains(event.target))
      detailsElement.removeAttribute("open");
  }

  onChange(event) {
    this.querySelectorAll(".list-card-product__link").forEach((anchor) => {
      const url = new URL(anchor.href);
      url.searchParams.set("variant", event.currentTarget.value);
      anchor.href = url.toString();
    });
    this.productVariant = event.currentTarget.value;
    this.querySelector('.list-card-product').classList.add("selected");
    this.querySelector('.list-card-product.selected .hide-input').hidden = true;
  }

  onClick(event) {
    event.preventDefault();
    this.loadProduct(event.currentTarget.href);
  }

  async loadProduct(url) {
    try {
      const sectionName = "list-card-product";

      const json = await fetch(`${url}?sections=${sectionName}`).then((res) =>
        res.json()
      );

      this.innerHTML = this.getSectionInnerHTML(json[sectionName], sectionName);
      this.bindEvents();
      this.addAccessibilityAttributes();
      // const button = this.querySelector("wishlist-button");
      // if ("_swat" in window) {
      //   button.init(window._swat);
      // } else {
      //   window.SwymCallbacks = window.SwymCallbacks || [];
      //   window.SwymCallbacks.push(button.init.bind(button));
      // }
      window.lazyloadPolyfill(this);
      window.convertCurrency(this);
      this.querySelector('.list-card-product').classList.add("selected");
      this.querySelector('.list-card-product.selected .hide-input').hidden = true;
      this.querySelector('.list-card-product select option[value="'+ this.productVariant +'"]').selected = true;
    } catch (error) {
      console.error(error);
    }
  }

  getSectionInnerHTML(html, selector) {
    const DOM = new DOMParser().parseFromString(html, "text/html");
    return DOM.querySelector(selector).innerHTML;
  }
}

customElements.define("list-card-product", ListCardProduct);
